// 🔧 scan_payload_parser.js
// ✅ Purpose: Parse raw QR scanner values into standardized LGV scan payloads
// ✅ Features:
// - Supports future LGV:// scanner payloads
// - Supports simple Passport codes as fallback
// - Keeps QR scanner UI free from business logic
// - Allows Passport, Voting, Tickets, Vendors, Sponsors, and future modules to share one scanner platform

import { SCAN_TYPES } from "./scan_types";

export const parseScanPayload = (rawValue = "") => {
  // Scanner adapters must provide text. Coercing numbers or objects here would
  // incorrectly turn malformed input into a valid legacy Passport code.
  if (typeof rawValue !== "string") {
    return {
      type: SCAN_TYPES.UNKNOWN,
      rawValue: "",
      valid: false,
      reason: "invalid_scan_type",
    };
  }

  const value = String(rawValue || "").trim();

  if (!value) {
    return {
      type: SCAN_TYPES.UNKNOWN,
      rawValue: value,
      valid: false,
      reason: "empty_scan",
    };
  }

  const normalized = value.replace(/^LGV:\/\//i, "").trim();
  const parts = normalized.split("/").filter(Boolean);

  if (parts.length >= 2) {
    const type = String(parts[0] || "").toLowerCase();
    const payloadId = parts.slice(1).join("/");

    if (Object.values(SCAN_TYPES).includes(type)) {
      return {
        type,
        rawValue: value,
        value: payloadId,
        valid: true,
      };
    }
  }

  // MVP fallback:
  // Existing Passport codes like SPONSOR420 should still work.
  return {
    type: SCAN_TYPES.PASSPORT,
    rawValue: value,
    value,
    valid: true,
    legacy: true,
  };
};
